'use client';

/*
 * Documentation:
 * BasicCard02 — https://app.subframe.com/6fc7f5fbb098/library?component=BasicCard02_bb555538-323e-4595-b7cb-def648559a6c
 * Icon with background — https://app.subframe.com/6fc7f5fbb098/library?component=Icon+with+background_c5d68c0e-4c0c-4cff-8d8c-6ff334859b3a
 */
import React from 'react';
import { FeatherBell } from '@subframe/core';
import * as SubframeCore from '@subframe/core';
import * as SubframeUtils from '../utils';
import { IconWithBackground } from '../common';
interface BasicCard02RootProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}
const BasicCard02Root = React.forwardRef<HTMLDivElement, BasicCard02RootProps>(function BasicCard02Root({
  icon = <FeatherBell />,
  title,
  description,
  className,
  ...otherProps
}: BasicCard02RootProps, ref) {
  return <div className={SubframeUtils.twClassNames('flex h-full w-full flex-col items-start gap-4 rounded-[16px] border border-solid border-neutral-200 bg-neutral-50 px-6 py-6', className)} ref={ref} {...otherProps}>
        <IconWithBackground size="large" icon={icon} />
        <div className="flex w-full flex-col items-start gap-2">
          {title ? <span className="text-heading-3 font-heading-3 text-default-font w-full">{title}</span> : null}
          {description ? <span className="text-body font-body text-default-font line-clamp-2 w-full">
              {description}
            </span> : null}
        </div>
      </div>;
});
export const BasicCard02 = BasicCard02Root;